// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","flow":"styles_flow__hVaGy"};